import { Breakpoint, useBreakpoint } from "@gik/core/hooks/CustomHooks";
import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { useTranslation } from "react-i18next";
import translationKeys from "../../i18n/en";
import { GiftTypeGridWithData } from "../GiftTypeGrid";

export type ByGiftTypeSectionProps = {
	title?: string;
	loadMoreButton?: boolean;
	fallbackData?: WordpressTaxonomy[];
} & UIComponent;

export function ByGiftTypeSection({
	title,
	className,
	loadMoreButton,
	fallbackData,
}: ByGiftTypeSectionProps): React.ReactElement {
	const bem = bemBlock("by-gift-type-section");
	const { t } = useTranslation();

	const isLgUp = useBreakpoint(Breakpoint.LG);
	const isXLUp = useBreakpoint(Breakpoint.XL);

	const initialItemNum = isXLUp ? 10 : isLgUp ? 8 : 6;

	return (
		<PageSection className={bem(null, null, className)}>
			<h2 className="gik-give-section-title">
				{title || t(translationKeys.byGiftTypeTitle)}
			</h2>
			<GiftTypeGridWithData
				cols={5}
				skeletonItems={initialItemNum}
				initialItemNum={initialItemNum}
				loadMoreButton={loadMoreButton}
				items={fallbackData}
			/>
		</PageSection>
	);
}
